export const initialValues = {
  homepage: {
    selected_membership: {
      title: "",
      value: "",
      description: "",
      base_price: 0,
      direct_debit_discount: 0,
      image: ""
    },
    selected_membership_control: "",
    payment_type: "",
    dob: "",
    ga_document_host: "",
    initial_location: "",
    membership_form_id: "",
    membership_form_name: "",
    ga_client_id: "",
    ga_tracking_id: "",
    gtm_container_id: "",
    session_id: "",
    manually_transferred_to_crm: false
  },
  details: {
    payment_method: "",
    optins_email: false,
    optins_second_adult_email: false,
    optins_post: false,
    optins_phone: false,
    optins_second_adult_post: false,
    optins_second_adult_phone: false,
    salutation: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    existing_membership_number: "",
    second_named_adult_first_name: "",
    second_named_adult_last_name: "",
    second_named_adult_email: "",
    second_named_adult_salutation: "",
    second_named_adult_phone: "",
    address_search: "",
    organisation: "",
    address_1: "",
    address_2: "",
    address_3: "",
    town_city: "",
    county_state: "",
    postcode: "",
    country: "GB",
    ticketPurchasedAt: "kew",
    previous_visit_date: "",
    previous_visit_ticket_number: ""
  },
  payment: {
    optins_giftaid: false
  },
  payment_regular: {
    bank_account_account_name: "",
    bank_account_account_number: "",
    bank_account_sort_code: "",
    bank_account_number_redacted: ""
  }
}

export default initialValues